export default () => ({
  items: [],
  paginator: { page: 0, size: 0, total: 0, loadingPage: null },
  sort: { field: "createdOn", order: "desc", loading: false },
  current: null,
  isLoading: false,
  dqlFields: {},
});
